"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Socials = exports.Social = exports.PrimaryLinks = exports.PrimaryLink = exports.GlobalFooterWrapper = exports.GlobalFooter = exports.FeaturedLinksContainer = exports.FeaturedLink = exports.Disclaimer = exports.Copyright = exports.Content = exports.CategoryTitleButton = exports.CategoryTitle = exports.CategoryLinks = exports.CategoryLink = exports.Category = exports.Categories = exports.Carrot = exports.Bottom = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../../components/breakpoints"));
var _DynamicHeading = require("../../components/DynamicHeading");
var _LexusTypography = require("../../components/LexusTypography");
var _Link = _interopRequireDefault(require("../../components/Link"));
var _Typography = require("../../components/Typography");
const GlobalFooter = exports.GlobalFooter = _styledComponents.default.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
`;
const FeaturedLinksContainer = exports.FeaturedLinksContainer = _styledComponents.default.div`
  display: flex;
  justify-content: center;
  gap: 25px;
  align-items: center;
  margin-bottom: 30px;
  ${(0, _breakpoints.default)("mobile")} {
    flex-direction: column;
    gap: 15px;
  }
`;
const FeaturedLink = exports.FeaturedLink = (0, _Typography.StyledType)(_Link.default, {
  family: "nobel-book",
  size: "linkCopy3"
})`
  text-decoration: none;
  text-align: center;
  display: flex;
  gap: 5px;
  color: #B6A171;
`;
const Content = exports.Content = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  ${(0, _breakpoints.default)("tablet", "up")} {
    flex-direction: row;
  }
`;
const PrimaryLinks = exports.PrimaryLinks = _styledComponents.default.div`
  width: 100%;
  margin-left: -10px;
  flex-grow: 1;
  flex-shrink: 0;

  ${(0, _breakpoints.default)("tablet")} {
    width: 33.33%;
    margin: 0;
  }

  ${(0, _breakpoints.default)("desktop", "up")} {
    width: 25%;
    margin: 0;
  }
`;
const PrimaryLink = exports.PrimaryLink = (0, _Typography.StyledType)(_Link.default, {
  family: "nobel-regular",
  size: "linkCopy3",
  letterSpacing: "wide"
})`
  color: inherit;
  display: inline-block;
  padding: 0 10px;
  border-right: 1px solid rgb(51, 51, 51);
  text-decoration: none;
  margin-bottom: 15px;

  &:last-of-type {
    border-right: none;
  }

  ${(0, _breakpoints.default)("tablet", "up")} {
    display: table;
    padding: 0;
    border-right: none;
  }
`;
const Categories = exports.Categories = _styledComponents.default.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 25px;

  ${(0, _breakpoints.default)("tablet", "up")} {
    margin-bottom: 0;
  }
`;
const Category = exports.Category = _styledComponents.default.div`
  width: 100%;
  ${(0, _breakpoints.default)("tablet")} {
    width: 50%;
    margin-bottom: 45px;
  }
  ${(0, _breakpoints.default)("desktop", "up")} {
    width: 33.33%;
    margin-bottom: 45px;
  }
`;
const CategoryTitle = exports.CategoryTitle = (0, _styledComponents.default)(_DynamicHeading.DynamicHeading).attrs({
  defaultLevel: 3
})`
  ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "link11_14",
  spacing: "wide"
})}
  ${(0, _breakpoints.default)("tablet", "up")} {
    margin: 0 0 25px;
  }
`;
const CategoryTitleButton = exports.CategoryTitleButton = (0, _Typography.StyledType)("button", {
  family: "nobel-regular",
  size: "linkCopy3",
  letterSpacing: "wide"
})`
  display: flex;
  width: 100%;
  background: none;
  color: inherit;
  border: none;
  padding: 25px 0;
  text-align: left;
  border-bottom: 1px solid rgb(51, 51, 51);
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
const CategoryLinks = exports.CategoryLinks = _styledComponents.default.div`
  border-bottom: 1px solid rgb(51, 51, 51);
  opacity: ${function (_ref) {
  let {
    $active
  } = _ref;
  return $active ? "1" : "0";
}};
  max-height: ${function (_ref2) {
  let {
    $active
  } = _ref2;
  return $active ? "100vh" : "0";
}};
  padding: ${function (_ref3) {
  let {
    $active
  } = _ref3;
  return $active ? "25px 0" : "0";
}};
  transform: ${function (_ref4) {
  let {
    $active
  } = _ref4;
  return $active ? "translate3d(0, 0, 0)" : "translate3d(0, -10px, 0)";
}};
  transform-style: preserve-3d;
  transition: all 0.6s ease;
  overflow: hidden;
  ${(0, _breakpoints.default)("tablet", "up")} {
    padding: 0;
    border: none;
  }
`;
const CategoryLink = exports.CategoryLink = (0, _Typography.StyledType)(_Link.default, {
  family: "nobel-book",
  size: "legalCopy1",
  letterSpacing: "wide"
})`
  color: inherit;
  display: table;
  text-decoration: none;
  margin-bottom: 10px;
  color: #ADADAD;
  padding: 10px 0 15px;

  &:last-child {
    margin-bottom: 0;
  }

  ${(0, _breakpoints.default)("tablet", "up")} {
    padding: 0;
    margin-bottom: 15px;
  }
`;
const Socials = exports.Socials = _styledComponents.default.div`
  margin: 25px 0 0;
  display: flex;
  padding: 0 10px;

  ${(0, _breakpoints.default)("tablet", "up")} {
    padding: 0;
  }
`;
const Social = exports.Social = (0, _styledComponents.default)(_Link.default)`
  color: inherit;
  padding: 0 5px;
  &:first-child {
    padding-left: 0;
  }
`;
const Bottom = exports.Bottom = _styledComponents.default.div`
  text-align: center;
  margin-top: 100px;

  text-align: left;
  ${(0, _breakpoints.default)("tablet", "up")} {
    text-align: center;
  }
`;
const Disclaimer = exports.Disclaimer = (0, _Typography.StyledType)(_Link.default, {
  family: "nobel-book",
  size: "linkCopy3"
})`
  color: inherit;
  display: inline-block;
  margin-bottom: 5px;
`;
const Copyright = exports.Copyright = (0, _Typography.StyledType)("div", {
  family: "nobel-book",
  size: "linkCopy3"
})`
  [data-page-theme="gr"] & {
    font-family: 'akkurat-mono';
    font-size: 11px;
    line-height: 24px;
  }
  display: block;
  color: #ADADAD;
`;
const Carrot = exports.Carrot = _styledComponents.default.div`
  padding: 0 15px;
  // transition: all 250ms ease-in-out;
  transform-origin: center;

  ${function (_ref5) {
  let {
    $active = false
  } = _ref5;
  return $active ? `
    transform: rotateZ(180deg);
  ` : "";
}}
`;
const GlobalFooterWrapper = exports.GlobalFooterWrapper = _styledComponents.default.div`
  [data-page-theme="gr"] & {
    font-family: 'akkurat-mono';

    /* TODO: Make the white category title links use Decima instead. */
    h2, a, p, span {
      font-family: 'akkurat-mono';
      text-transform: uppercase;
    }

    ${Bottom} a {
      margin-bottom: 10px;
    }
  }

  background: #000;
  display: block;
  position: relative;
  color: #fff;
  box-sizing: border-box;
  padding: 35px 15px 65px;
`;
var _default = exports.default = {};